export function Document(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="18"
        height="24"
        viewBox="0 0 18 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.0633 0.800003H4.00005C2.23274 0.800003 0.800049 2.23269 0.800049 4V20C0.800049 21.7673 2.23274 23.2 4.00005 23.2H14C15.7674 23.2 17.2 21.7673 17.2 20V8.7241C17.2 7.97551 16.9376 7.2506 16.4584 6.67551L12.5216 1.95141C11.9136 1.22184 11.013 0.800003 10.0633 0.800003ZM9.20005 3.2H10.0633C10.3007 3.2 10.5259 3.30546 10.6779 3.48786L14.6146 8.21196C14.7344 8.35573 14.8 8.53695 14.8 8.7241V10.8H10L9.8997 10.7938C9.50524 10.7444 9.20005 10.4078 9.20005 10V3.2ZM6.80005 3.2H4.00005C3.55822 3.2 3.20005 3.55818 3.20005 4V20C3.20005 20.4418 3.55822 20.8 4.00005 20.8H14C14.4419 20.8 14.8 20.4418 14.8 20V13.2H10C8.29368 13.2 6.89925 11.8644 6.80511 10.1816L6.80005 10V3.2Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
